// @flow
import React, { PureComponent } from "react";
import {
  get,
  find,
  isEmpty,
  noop,
  isEqual,
  flowRight as compose
} from "lodash";
import { graphql } from "@apollo/client/react/hoc";
import { withRouter } from "react-router-dom";
import tvgConf from "@tvg/conf";
import type { RaceProgram } from "@tvg/types/Race";
import ProgramPageMask from "@tvg/atomic-ui/_static/Masks/program-page";
import ProgramPageTabletMask from "@tvg/atomic-ui/_static/Masks/program-page-tablet";
import mediator from "@tvg/mediator";
import RaceQuery from "./graphql/queries/RaceProgramQuery.graphql";
// $FlowFixMe
import LiveTvgQuery from "./graphql/queries/RaceProgramLiveTvgQuery.graphql";
// $FlowFixMe
import RaceProgramProbablesQuery from "./graphql/queries/RaceProgramProbablesQuery.graphql";
import RaceProgramSubscription from "./graphql/queries/RaceProgramSubscription.graphql";
import ApolloOptions, {
  LiveTvgOptions,
  ProbableOptions
} from "./graphql/options.graph";
import RPComponent from "./ProgramPageComponent";
import type { Props, State } from "./types";

export class ProgramPage extends PureComponent<Props, State> {
  static defaultProps = {
    liveTvg: false,
    liveTvg2: false,
    device: "mobile",
    wagerType: "",
    selections: [],
    betAmount: "",
    hasRequestedSession: false,
    selectedRunner: "",
    isFixed: false,
    betType: "",
    fcpClient: null,
    behgClient: null,
    subscribeToMore: noop,
    hasWebSockets: false
  };

  raceSubscriptions: ?() => void;

  constructor() {
    super();
    this.raceSubscriptions = null;
    this.state = {
      openVideoFromMyBets: false
    };
  }

  componentDidMount() {
    const races = this.getRaces(this.props);
    if (races.length && this.props.hasWebSockets) {
      this.updateSubscription(races);
    }
    mediator.base.dispatch({
      type: "TVG_LOGIN:GET_USER_PROMOS"
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const races = this.getRaces(this.props);
    const previousRaces = this.getRaces(prevProps);
    const hasRacesChanged = !isEqual(
      previousRaces.map((value) => value.id),
      races.map((value) => value.id)
    );

    if (
      races.length &&
      this.props.hasWebSockets &&
      (hasRacesChanged || !this.raceSubscriptions)
    ) {
      this.updateSubscription(races);
    }

    this.onUpdate(prevProps, prevState);
  }

  onUpdate = (prevProps: Props, prevState: State) => {
    const openVideo = get(this.props, "location.state.openVideo", false);
    if (
      this.props.trackName !== prevProps.trackName ||
      this.props.raceNumber !== prevProps.raceNumber ||
      (prevState !== undefined &&
        this.state.openVideoFromMyBets !== prevState.openVideoFromMyBets)
    ) {
      this.setState({ openVideoFromMyBets: openVideo });
    }

    if (!this.state.openVideoFromMyBets && openVideo) {
      this.setState({ openVideoFromMyBets: openVideo });
    }
  };

  getRaces = (props: Props) =>
    (props.liveTvg || props.liveTvg2 ? props.liveTvgRaces : props.races) || [];

  updateSubscription = (races: RaceProgram[]) => {
    if (typeof this.props.subscribeToMore !== "function") {
      return;
    }
    if (typeof this.raceSubscriptions === "function") {
      this.raceSubscriptions();
    }
    this.raceSubscriptions = get(
      this.props,
      "subscribeToMore"
    )({
      document: RaceProgramSubscription,
      variables: {
        wagerProfile: get(this.props, "wagerProfile", ""),
        tvgRaceIds: races.map((race) => get(race, "tvgRaceId")),
        productPromo: tvgConf().product,
        brandPromo: tvgConf().brand,
        // # To delete sourcePage after debugging UW-1703
        sourcePage: "Programme Page",
        ...tvgConf().graphContext()
      }
    });
  };

  render() {
    const race =
      find(
        this.props.races,
        (tempRace) => tempRace.raceNumber === this.props.raceNumber
      ) || {};
    const hasLiveTVG = this.props.liveTvg || this.props.liveTvg2;
    const isQueryLoading =
      get(this.props, "isLoading", true) ||
      get(this.props, "isLoadingLiveTvg", hasLiveTVG);
    const isRacesEmpty = get(this.props, "races.length") === 0;
    const hasRequestedSession = get(this.props, "hasRequestedSession");
    const probables =
      this.props.racesWithProbables?.[+this.props.raceNumber - 1]?.probables;
    let channel = "";

    if (
      !isQueryLoading &&
      hasRequestedSession &&
      (isRacesEmpty || isEmpty(race))
    ) {
      if (typeof window !== "undefined") {
        window.location.href = "/";
      }
    }

    if (hasLiveTVG) {
      channel = this.props.liveTvg ? "TVG" : "TVG2";
    }

    const ProgramPageLoadingMask =
      this.props.device === "tablet" ? (
        <ProgramPageTabletMask />
      ) : (
        <ProgramPageMask />
      );

    return !isEmpty(race) ? (
      <RPComponent
        fcpClient={this.props.fcpClient}
        behgClient={this.props.behgClient}
        hasWebSockets={this.props.hasWebSockets}
        selectedRunner={this.props.selectedRunner}
        defaultBetType={this.props.betType}
        channel={channel}
        trackAbbr={this.props.trackAbbr}
        liveTvgRaces={get(this.props, "liveTvgRaces", [])}
        shouldUpdate={this.props.shouldUpdate}
        races={get(this.props, "races", [])}
        currentRace={race}
        raceNumber={+this.props.raceNumber}
        columnLayout={this.props.device === "mobile" ? "single" : "dual"}
        isFixed={this.props.isFixed}
        wagerType={this.props.wagerType}
        selections={this.props.selections}
        betAmount={this.props.betAmount}
        openVideoFromMyBets={this.state.openVideoFromMyBets}
        history={this.props.history}
        probables={probables}
      />
    ) : (
      ProgramPageLoadingMask
    );
  }
}

export default withRouter(
  compose(
    graphql(RaceQuery, ApolloOptions),
    graphql(LiveTvgQuery, LiveTvgOptions),
    graphql(RaceProgramProbablesQuery, ProbableOptions)
  )(ProgramPage)
);
